module.exports = __webpack_public_path__ + "img/vi-ico.7fb3758b.svg";